import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';

const COOKIE_KEY = 'cookie_accepted';

@Component({
  selector: 'app-cookie',
  templateUrl: './cookie.component.html',
  styleUrls: ['./cookie.component.scss']
})
export class CookieComponent implements OnInit {

  cookie_settings;

  form : FormGroup;

  constructor(public bsModalRef: BsModalRef, private fb : FormBuilder) {
    try {
      this.cookie_settings = JSON.parse(localStorage.getItem(COOKIE_KEY));
    }
    catch (err) {}

    this.form = this.fb.group({
      'facebook_pixel': [true],
      'google_analytics': [true],
      'facebook_live_chat': [true]
    });
    
    if (this.cookie_settings) {
      this.form.patchValue(this.cookie_settings);
    }
  }

  ngOnInit(): void {
  }

  saveClicked;
  saveAndClose() {
    let newValue = this.form.value;
    localStorage.setItem(COOKIE_KEY, JSON.stringify(newValue));
    if (this.cookie_settings) {
      location.reload();
    }

    this.saveClicked = true;

    this.bsModalRef.hide();
  }

}
